module.exports = __webpack_public_path__ + "img/59ne.35308d69.svg";